import { Action } from '@ngrx/store';
import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { OrderDetailQueryParams } from '@ordersnproducts/modules/orders-and-product-catalog/modules/order-detail/constants/order-detail-query-params';

export enum RepeatOrderSelectedDetailActionTypes {
  LOAD = '[OrderSelectedDetail Repeat] Load order detail',
  LOAD_SUCCESS = '[OrderSelectedDetail Repeat] Load order detail success',
  RESET = '[OrderSelectedDetail Repeat] Reset',
  LOAD_ONLINE = '[OrderSelectedDetail Repeat] Load order ONLINE detail',
  CREATE_RECIPES = '[OrderSelectedDetail Repeat] Load order recipes values',
  CREATE_RECIPES_REQUEST = '[OrderSelectedDetail Repeat] Load order recipes values REQUEST experience',
  RESET_PROGRAMMED_DATE_TIME = '[OrderSelectedDetail Repeat] Reset programmed date time',
}

export class RepeatOrderSelectedDetailLoad implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.LOAD;

  constructor(public payload: OrderDetailQueryParams) {}
}

// USED BY BULK-US FOR RECIPE CREATION
// TODO: CHECK RepeatOrderSelectedCreateFormRecipes USAGE
export class RepeatOrderSelectedDetailOnline implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.LOAD_ONLINE;

  constructor(public payload: Order) {}
}

export class RepeatOrderSelectedCreateFormRecipes implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.CREATE_RECIPES;

  constructor(public payload: Order) {}
}

export class RepeatRequestCreateFormRecipes implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.CREATE_RECIPES_REQUEST;

  constructor(public payload: Order) {}
}

export class RepeatOrderSelectedDetailLoadSuccess implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.LOAD_SUCCESS;

  constructor(public payload: Order) {}
}

export class RepeatOrderSelectedDetailReset implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.RESET;

  constructor(public payload: any) {}
}

export class RepeatOrderSelectedDetailResetProgrammedDateTime implements Action {
  readonly type = RepeatOrderSelectedDetailActionTypes.RESET_PROGRAMMED_DATE_TIME;

  constructor(public payload: any) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type OrderSelectedDetailActions =
  | RepeatOrderSelectedDetailLoad
  | RepeatOrderSelectedDetailLoadSuccess
  | RepeatOrderSelectedDetailOnline
  | RepeatOrderSelectedDetailReset
  | RepeatOrderSelectedCreateFormRecipes
  | RepeatRequestCreateFormRecipes
  | RepeatOrderSelectedDetailResetProgrammedDateTime;
